<template>
    <div class="text-center">
        <InfoAlert :showDismissibleAlert="showDismissibleAlert" v-on:close="showDismissibleAlert=false" :info="info" />  
        <v-btn :dark="$store.getters.getColorPalette().isDark" small color="teal accent-3" @click="dialog = !dialog">
            <v-icon small>mdi-plus</v-icon>
        </v-btn>
        <v-dialog v-model="dialog" fullscreen hide-overlay transition="dialog-bottom-transition">
            <v-card :dark="$store.getters.getColorPalette().isDark"
                :color="$store.getters.getColorPalette().background2ColorCode">
                <v-toolbar :dark="$store.getters.getColorPalette().isDark"
                    :color="$store.getters.getColorPalette().foregroundColorCode">
                    <v-btn icon :dark="$store.getters.getColorPalette().isDark" @click="dialog = false">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                    <v-toolbar-title>{{ $store.getters.getTextMap().oee }}</v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-toolbar-items>
                        <v-btn :dark="$store.getters.getColorPalette().isDark" text @click="dialog = false">
                            {{ $store.getters.getTextMap().close }}
                        </v-btn>
                    </v-toolbar-items>
                </v-toolbar>
                <v-container>
                    <v-row>
                        <v-col>
                            <v-skeleton-loader v-if="loading" class="mx-auto" type="text"></v-skeleton-loader>
                            <v-select  
                                v-if="!loading"
                                v-model="shift"
                                :items="shiftOptions"
                                :label="$store.getters.getTextMap().shift"
                                dense
                                outlined
                                item-text="label"
                                item-value="value"
                                :menu-props="{dark: $store.getters.getColorPalette().isDark}"
                                required
                                :dark="$store.getters.getColorPalette().isDark" 
                                :rules="objectRules"
                            ></v-select  >
                        </v-col>
                        <v-col>
                            <v-skeleton-loader v-if="loading" class="mx-auto" type="text"></v-skeleton-loader>
                            <v-select  
                                v-if="!loading"
                                v-model="machines"
                                :items="machineOptions"
                                :label="$store.getters.getTextMap().machine"
                                dense
                                outlined
                                item-text="label"
                                item-value="value"
                                :menu-props="{dark: $store.getters.getColorPalette().isDark}"
                                required
                                multiple
                                :dark="$store.getters.getColorPalette().isDark" 
                                :rules="objectRules"
                            ></v-select  >
                        </v-col>
                        <v-col>
                            <v-menu 
                                :dark="$store.getters.getColorPalette().isDark"
                                :color="$store.getters.getColorPalette().inputtextColor"
                                v-model="menu1"
                                :close-on-content-click="false"
                                :nudge-right="40"
                                transition="scale-transition"
                                offset-y
                                min-width="290px"
                            >
                                <template v-slot:activator="{ on, attrs }">
                                    <v-text-field :dark="$store.getters.getColorPalette().isDark"
                                        :color="$store.getters.getColorPalette().inputtextColor"
                                        v-model="from_date"
                                        :label="$store.getters.getTextMap().from_date"
                                        prepend-icon="mdi-calendar"
                                        readonly
                                        outlined
                                        dense
                                        :loading="loading"
                                        v-bind="attrs"
                                        v-on="on"
                                        :rules="ISODateRules"
                                    ></v-text-field>
                                </template>
                                <v-date-picker 
                                    :dark="$store.getters.getColorPalette().isDark"
                                    :color="$store.getters.getColorPalette().inputtextColor"
                                    v-model="from_date"
                                    @input="menu1 = false"
                                ></v-date-picker>  
                            </v-menu>
                        </v-col>
                        <v-col>
                            <v-menu 
                                :dark="$store.getters.getColorPalette().isDark"
                                :color="$store.getters.getColorPalette().inputtextColor"
                                v-model="menu2"
                                :close-on-content-click="false"
                                :nudge-right="40"
                                transition="scale-transition"
                                offset-y
                                min-width="290px"
                            >
                                <template v-slot:activator="{ on, attrs }">
                                    <v-text-field :dark="$store.getters.getColorPalette().isDark"
                                        :color="$store.getters.getColorPalette().inputtextColor"
                                        v-model="to_date"
                                        :label="$store.getters.getTextMap().to_date"
                                        outlined
                                        dense
                                        prepend-icon="mdi-calendar"
                                        readonly
                                        :loading="loading"
                                        v-bind="attrs"
                                        v-on="on"
                                        :rules="ISODateRules"
                                    ></v-text-field>
                                </template>
                                <v-date-picker 
                                    :dark="$store.getters.getColorPalette().isDark"
                                    :color="$store.getters.getColorPalette().inputtextColor"
                                    v-model="to_date"
                                    @input="menu2 = false"
                                ></v-date-picker>
                            </v-menu>
                        </v-col>
                    </v-row>
                    <v-row v-if="tableData && tableData.length>0">
                        <v-col>
                            <v-data-table
                                :headers="headers"
                                :items="tableData"
                                item-key="index"
                                :search="search"
                                :single-expand="true"
                                show-expand
                                :expanded.sync="expanded"
                                :loading="loading"
                                loading-text="Loading... Please wait"
                                :dark="$store.getters.getColorPalette().isDark" 
                            >
                                <template v-slot:top>
                                    <v-toolbar flat :dark="$store.getters.getColorPalette().isDark">
                                        <v-toolbar-title>{{ $store.getters.getTextMap().down_times }}</v-toolbar-title>
                                        <v-divider class="mx-4" inset vertical></v-divider>
                                        <v-spacer></v-spacer>
                                    </v-toolbar>
                                </template>
                                <template v-slot:expanded-item="{ headers, item }">
                                    <td :colspan="headers.length">
                                        <AddDowntimeReason :downtimeBucket="item" v-on:update="getData"/>
                                    </td>
                                </template>
                            </v-data-table>
                        </v-col>
                    </v-row>
                </v-container>
            </v-card>
        </v-dialog>
    </div>
</template>
<script>
import InfoAlert from '@/components/InfoAlert';
import axios from 'axios';
import moment from "moment";
import AddDowntimeReason from '@/components/crud_components/oee/AddDowntimeReason.vue';
export default {
    name: 'AddDowntimeReasonModal',
    components: {
        InfoAlert,
        AddDowntimeReason
    },
    data() {
        return {
            dialog: false,
            showDismissibleAlert:false,
            loading:false,
            info: '',
            shiftOptions: [],
            machineOptions:[],
            shift: null,
            machines: [],
            menu1:false,
            menu2: false,
            to_date:null,
            from_date: null,
            tableData: [],
            expanded: [],
            search:'',
            headers: [
              {
                text: 'Date',
                align: 'start',
                filterable: false,
                value: 'formatted_date',
                class: " text-capitalize font-weight-black "+this.$store.getters.getColorPalette().tableHeaderColorName
              },
              { text: 'Shift', value: 'shift_name', class: " text-capitalize font-weight-black "+this.$store.getters.getColorPalette().tableHeaderColorName },
              { text: 'Machine', value: 'machine_name', class: " text-capitalize font-weight-black "+this.$store.getters.getColorPalette().tableHeaderColorName },
              { text: 'From Time', value: 'from_time', class: " text-capitalize font-weight-black "+this.$store.getters.getColorPalette().tableHeaderColorName },
              { text: 'Down Time From', value: 'downtime_from', class: " text-capitalize font-weight-black "+this.$store.getters.getColorPalette().tableHeaderColorName },
              { text: 'Downtime Duration', value: 'downtime_duration', class: " text-capitalize font-weight-black "+this.$store.getters.getColorPalette().tableHeaderColorName },
              { text: 'Downtime Type', value: 'downtime_type', class: " text-capitalize font-weight-black "+this.$store.getters.getColorPalette().tableHeaderColorName },
              { text: 'Downtime Reason', value: 'downtime_reason', class: " text-capitalize font-weight-black "+this.$store.getters.getColorPalette().tableHeaderColorName },
              { text: 'Remarks', value: 'remarks', class: " text-capitalize font-weight-black "+this.$store.getters.getColorPalette().tableHeaderColorName },
              { text: 'Details', value: 'details', class: " text-capitalize font-weight-black "+this.$store.getters.getColorPalette().tableHeaderColorName },
              { text: 'User ID', value: 'userid', class: " text-capitalize font-weight-black "+this.$store.getters.getColorPalette().tableHeaderColorName },
            ],
            objectRules: [
                v => !!v || this.$store.getters.getTextMap().required,
            ],
            ISODateRules:[
                v => !!v ||this.$store.getters.getTextMap().required,
                v => /[0-9][0-9][0-9][0-9]-[0-9][0-9]-[0-9][0-9]$/.test(v) || 'It should be a Date',
            ]
        }
    },
    mounted() {
        this.from_date=moment().startOf('month').format('YYYY-MM-DD')
        this.getShifts()
    },
    methods: {
        getShifts(){
            let op=[]
            this.loading = true;
            axios.get(this.$store.state.api + "shifts",{headers: {Authorization: 'Bearer '+ this.$store.state.jwt}})
            .then(response => {
            if (response.data.status == "success") {
                let shifts=response.data.data
                for(let i of shifts){
                    op.push({value:i.shift_id, label: i.name })
                }
            } else {
                this.info = response.data.msg;
                this.showDismissibleAlert = true;
            }
                this.loading = false;
            })
            .catch(error => {
                this.info = error;
                this.showDismissibleAlert = true;
                this.loading = false;
            });
          this.shiftOptions = op
        },
        getMachines() {
            this.loading=true
            let op = []
            axios.post(this.$store.state.api+'getMachinesByShift',{shift_id:this.shift},{headers: {Authorization: 'Bearer '+ this.$store.state.jwt}})
            .then(response=>{
                if (response.data.status == 'success') {
                    let machines = response.data.data
                    for(let i of machines){
                        if(i && i.name){
                            op.push({value:i.machine_id, label: i.name })
                        }else{
                            op.push({value:i.machine_id, label: i.machine_id })
                        }
                    }
                    this.loading=false
                }else{
                    this.loading=false
                    this.info=response.data.msg
                    this.showDismissibleAlert=true
                }
            }).catch(err=>{
                this.loading=false
                this.info=err
                this.showDismissibleAlert=true
            })
            this.machineOptions=op
        },
        getData() {
            this.loading = true;
            let payload = {
                machines: this.machines,
                shift_id: this.shift,
                from_date: this.from_date,
                to_date:this.to_date
            }
            axios.post(this.$store.state.api + "getShiftAndMachineWiseDowntimeBetweenDate",payload,{headers: {Authorization: 'Bearer '+ this.$store.state.jwt}})
            .then(response => {
            if (response.data.status == "success") {
                let dbData = response.data.data
                let temp = []
                let index = 0
                for (let i of dbData) {
                    let machineDetails = this.$store.getters.getMachineById(i.machine_id)
                    let shiftDetails = this.$store.getters.getShiftById(i.shift_id)
                    temp.push(
                        {
                            index,
                            shift_id: i.shift_id,
                            machine_id:i.machine_id,
                            shift_name:shiftDetails && shiftDetails.name?shiftDetails.name: i.shift_id,
                            machine_name:machineDetails && machineDetails.name?machineDetails.name:i.machine_id,
                            date:i.date,
                            formatted_date:moment(i.date).format("DD-MM-YYYY"),
                            from_time: i.from_time,
                            downtime_from: moment(i.downtime_from).format("DD-MM-YYYY: HH-MM"),
                            downtime_from_epoch:i.downtime_from_epoch,
                            downtime_duration: i.downtime_duration,
                            downtime_type: i.downtime_type,
                            downtime_reason: i.downtime_reason,
                            remarks: i.remarks,
                            details: i.details,
                            userid:i.userid
                        }
                    )
                    index=index+1
                }
                this.tableData=temp
            } else {
                this.info = response.data.msg;
                this.showDismissibleAlert = true;
            }
                this.loading = false;
            })
            .catch(error => {
                this.info = error;
                this.showDismissibleAlert = true;
                this.loading = false;
            });
        }
    },
    watch: {
        shift() {
            this.machines=[]
            this.getMachines()
        },
        machines() {
            if (this.shift && this.from_date && this.machines && this.machines.length>0) {
                this.getData()
            }
        },
        to_date() {
            if (this.shift && this.from_date && this.machines && this.machines.length>0) {
                this.getData()
            }
        },
        from_date() {
            if (this.shift && this.from_date && this.machines && this.machines.length>0) {
                this.getData()
            }
        }
    }
}
</script>
